
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class FranchiseeOrdersDialog extends Serenity.EntityDialog<FranchiseeOrdersRow, any> {
        protected getFormKey() { return FranchiseeOrdersForm.formKey; }
        protected getIdProperty() { return FranchiseeOrdersRow.idProperty; }
        protected getLocalTextPrefix() { return FranchiseeOrdersRow.localTextPrefix; }
        protected getNameProperty() { return FranchiseeOrdersRow.nameProperty; }
        protected getService() { return FranchiseeOrdersService.baseUrl; }
        protected getDeletePermission() { return FranchiseeOrdersRow.deletePermission; }
        protected getInsertPermission() { return FranchiseeOrdersRow.insertPermission; }
        protected getUpdatePermission() { return FranchiseeOrdersRow.updatePermission; }

        protected form = new FranchiseeOrdersForm(this.idPrefix);
        constructor() {
            super();

            this.form.FranchiseeId.change(e => {
                var FranchiseeId = this.form.FranchiseeId.value;
                //debugger;
                if (Q.isEmptyOrNull(FranchiseeId)) {
                    // this.setProductDetails({});
                    this.form.OrderProducts.FranchiseeId = null;
                }
                else {

                    this.form.OrderProducts.FranchiseeId = parseInt(FranchiseeId);
                    FranchiseeOrdersService.RetrieveFranchisee({
                        EntityId: parseInt(FranchiseeId)
                    }, response => {
                            this.setCustomDetails(response.Entity);
                    });
                }

            });

        }

        protected afterLoadEntity() {
            if (Authorization.hasPermission("Users:Franchisee") && !Authorization.hasPermission("Administration:Security")) {
                this.form.FranchiseeId.set_value(this.form.FranchiseeId.items[0].id);
            }
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

        loadEntity(entity: FranchiseeOrdersRow) {
            super.loadEntity(entity);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'OrderShipping', this.isNewOrDeleted());
            if (!this.isNew()) {
                Serenity.EditorUtils.setReadonly(this.form.FranchiseeId.element, true);
                Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
            }

            this.form.FranchiseeId.change(e => {
                var vStateId = this.form.FranchiseeId.value;
                //debugger;
                if (Q.isEmptyOrNull(vStateId)) {
                    // this.setProductDetails({});

                }
                else {

                    var id1 = vStateId;
                    this.form.OrderProducts.FranchiseeId = parseInt(vStateId);
                }

            });

        }

        private setCustomDetails(details: Users.FranchiseeRow) {


            this.form.BillingAddress1.value = details.Address;
            //this.form.BillingAddress2.value = details.BillingAddress2;
            this.form.BillingCity.value = details.City;
            this.form.BillingStateId.value = details.StateId.toString();

            this.form.BillingPincode.value = details.Pincode;
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();
            //debugger;
            buttons.splice(3, 3);
            if (Authorization.hasPermission("Administration:Security")) {
                buttons.push({
                    title: Q.text('Mark As Paid'),
                    cssClass: 'send-button',
                    icon: 'fa fa-lock text-green',
                    onClick: () => {
                        Q.confirm("Are you sure You want to Mark As Paid?", () => {
                            this.form.MarkAsPaid.value = true;
                            this.saveAndCloseButton.click();
                        });

                    }
                });
            }
            buttons.push({
                title: 'Pay With Instamojo',
                cssClass: 'add-button',
                onClick: () => {
                    Q.confirm('Are you sure to make payment?', () => {
                        var param = {
                            'OrderId': this.entity.Id
                        };
                        var url = "/Orders/OnlinePayment";
                        debugger;
                        this.OpenWindowWithPostData(url, "", "PaymentGateway", param);
                    });

                }
            });

            buttons.push({
                title: 'Pay With Easebuzz',
                cssClass: 'add-button',
                onClick: () => {
                    Q.confirm('Are you sure to make payment?', () => {
                        //var eaebuzzsetting = Q.tryFirst(Orders.EaseBuzzSettingsRow.getLookup().items, x => x.IsActive == 1);
                        //if (eaebuzzsetting == undefined) {
                        //    Q.alert("Easebuzz Settings not found");
                        //    return;
                        //}
                        var param = {
                            'OrderId': this.entity.Id
                        };
                        var url = "/Orders/PayWithEaseBuzz";
                        debugger;
                        this.OpenWindowWithPostData(url, "", "PaymentGateway", param);
                    });

                }
            });

            buttons.push({
                title: 'Generate SerialKey',
                cssClass: 'add-button',
                onClick: () => {
                    Q.confirm('Verify Specification is correct if any Before Generating Serial Key,Are you sure to make Generate SerialKey?', () => {
                        this.form.GenerateSerialKey.value = true;
                        this.applyChangesButton.click();
                      
                    });

                }
            });

            return buttons;
        }
        

        protected OpenWindowWithPostData(url, windowoption, name, params) {
            var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", url);
            form.setAttribute("target", name);
            for (var i in params) {
                if (params.hasOwnProperty(i)) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = i;
                    input.value = params[i];
                    form.appendChild(input);
                }
            }
            document.body.appendChild(form);
            window.open(url, name, windowoption);
            form.submit();
            document.body.removeChild(form);
        }
    }
}